<template>
  <div class="wad4-steps-indicator">
    <div
        class="wad4-steps-indicator__step"
        v-for="(_, index) in props.totalSteps"
        :key="index"
        :class="[
      index < props.currentStep ? 'wad4-steps-indicator__step--past' :
      index === props.currentStep ? 'wad4-steps-indicator__step--current' :
      'wad4-steps-indicator__step--future'
    ]"
    />
  </div>
</template>

<script setup lang="ts">
const props = defineProps<{
  totalSteps: number
  currentStep: number
}>()
</script>
<style lang="scss">
.wad4-steps-indicator {
  display: flex;
  gap: 10px;
  align-self: center;
  padding: 10px;
  &__step {
    width: 50px;
    height: 4px;
    background-color: $wad4-c-background-bg-tertiery;
    border-radius: 4px;

    &--past {
      background-color: $wad4-c-background-bg-brand-solid;
    }

    &--current {
      background-color: $wad4-c-background-bg-brand-solid;
    }

    &--future {
      background-color: $wad4-c-background-bg-tertiery;
    }
  }
}
</style>
